export default "__VITE_ASSET__D2K2eojS__"